import {LoaderBig} from './LoaderBig';

export const LoaderFullScreen = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoaderBig />
    </div>
  );
};
